import { Box, Stack, Typography } from "@mui/material";
import { ScheduleClassCard } from "./ScheduleClassCard";
import { groupScheduleByDate } from "../utils/dateRangeUtils";

export function ScheduleListView({ assignments }) {
  const groupedAssignments = groupScheduleByDate(assignments);

  return (
    <Stack gap={4}>
      {Object.entries(groupedAssignments).map(([date, dateAssignments]) => (
        <Box key={date}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {date}
          </Typography>
          <Stack gap={2}>
            {dateAssignments.map((assignment) => (
              <ScheduleClassCard
                key={`${assignment.eventId || assignment.rawId || assignment.transactionId}-${assignment.start}`}
                assignment={assignment}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
